<template>
  <b-row>
    <b-col lg="12">
      <!-- .name -->
      <validation-observer ref="registerForm" #default="{ invalid }">
        <b-form>
          <b-row>
            <b-col lg="12">
              <b-tabs content-class="mt-3">
                <b-tab
                  :title="lang.name"
                  v-for="lang in languages"
                  :key="lang.id"
                >
                  <!-- .title -->
                  <b-col lg="12">
                    <b-form-group
                      id="input-group-7"
                      :label="$t('pages.title')"
                      label-for="input-7"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="title"
                        vid="title"
                        rules="required"
                      >
                        <b-form-input
                          id="input-7"
                          v-model="title[lang.code]"
                          type="text"
                          :placeholder="$t('pages.title')"
                          :state="errors.length > 0 ? false : null"
                        >
                        </b-form-input>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <!-- .content -->
                  <b-col lg="12">
                    <b-form-group
                      id="input-group-8"
                      :label="$t('pages.content')"
                      label-for="input-8"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="content"
                        vid="content"
                        rules="required"
                      >
                        <ckeditor
                          :config="{ contentsLangDirection : 'rtl',versionCheck : false}" 
                          id="input-8"
                          v-model="content[lang.code]"
                        >
                        </ckeditor>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-tab>
              </b-tabs>
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <!-- .image -->
            <b-col lg="6">
              <b-form-group
                id="input-group-4"
                :label="$t('news.image')"
                label-for="input-4"
              >
                <b-form-file
                  v-model="newItem.image"
                  placeholder="Choose a file or drop it here..."
                  drop-placeholder="Drop file here..."
                />
              </b-form-group>
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col lg="6">
              <b-button
                block
                :disabled="invalid"
                variant="primary"
                @click="submit()"
              >
                <i class="fa fa-plus" /> {{ $t("site.save") }}
              </b-button>
            </b-col>
            <b-col lg="6">
              <b-button block  @click="goToTable()" variant="success">
                <i class="fas fa-ban"></i> {{ $t("site.cancel") }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-col>
  </b-row>
</template>

<script>
import VideoGallery from "@/Controllers/VideoGalleryController";
import config from "@/config/config";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import LanguagesController from "@/Controllers/LanguagesController";
export default {
  name: "VideoForm",
  props: ["newItem"],
  components: {
    ValidationProvider,
    ValidationObserver,
    required,
  },
  data() {
    return {
      file: {},
      
      title: [],
      content: [],
      languages: [],
    };
  },
  async created() {
    this.languages = await new LanguagesController().GetActivelanguages();
  },
  methods: {
    async    goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {
      this.languages.forEach((element) => {
        this.newItem[element.code] = {
          title: this.title[element.code],
        };
      });
      this.newItem.type = 1;
      let res = await new VideoGallery().From(this.newItem, "FormData");
      if (res) {
        this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
        this.$parent.$parent.firstTab();
      }
    },
  },
  watch: {
    newItem(old) {
      this.languages.forEach((element) => {
        let locale = old.translations.find((a) => a.locale == element.code);

        this.$set(this.title, element.code, locale.title);
      });
    },
  },
};
</script>

